import { useMemo } from 'react';

import {
  PageDescriptor,
  PageRouteRef,
  getPageDescriptor,
} from './pageRegistry';

export const useBreadcrumbAncestors = (
  routeRef: PageRouteRef,
): PageDescriptor[] => {
  return useMemo(() => {
    const ancestors: PageDescriptor[] = [];
    let cursor = getPageDescriptor(routeRef, { required: false })?.parent;

    while (cursor) {
      const descriptor = getPageDescriptor(cursor, { required: false });
      if (!descriptor) {
        throw new Error(
          'Breadcrumb parent is not a registered page. All ancestors referenced by route.parent must be created via createPageRoute().',
        );
      }

      ancestors.unshift(descriptor);
      cursor = descriptor.parent;
    }

    return ancestors;
  }, [routeRef]);
};
